import { usePathname } from 'next/navigation'
import Button from './Button'
import useRedirectStorage from '../../lib/useRedirectStorage'
import { useTranslation } from '../../lib/i18n'

const JoinPlatformButton = () => {
  const pathname = usePathname()
  useRedirectStorage(pathname)
  const { t } = useTranslation()

  return (
    <Button primary tiny href="/signup">
      {t('common.joinPlatform')}
    </Button>
  )
}

export default JoinPlatformButton
